export default __webpack_public_path__ + "static/media/person-2-safari-14.aaf8a105.png";